import { setShowPaidLoadingScreen, setIsPaid } from '../store/userSlice';

export const handlePayment = async ({ dispatch }) => {
  try {
    console.log('🚀 Начало процесса оплаты');
    
    const initialLoader = document.querySelector('.loading-screen');
    if (initialLoader) {
      initialLoader.style.display = 'flex';
    }

    const initData = window.Telegram.WebApp.initData;

    const response = await fetch(`${process.env.REACT_APP_WEBAPP_URL}/api/create-invoice-stars`, {
      method: 'POST',
      body: JSON.stringify({ starsCount: 1, initData }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Ошибка при создании инвойса:', errorData);
      return;
    }

    const data = await response.json();
    console.log('✅ Инвойс получен:', data);

    const invoiceUrl = data.invoice_url;
    
    // Подписываемся на событие закрытия инвойса
    window.Telegram.WebApp.onEvent('invoiceClosed', async (event) => {
      console.log('📊 Инвойс закрыт:', event);
      
      if (event.status === 'paid') {
        console.log('✅ Оплата успешна, обновляем данные пользователя');
        
        dispatch(setShowPaidLoadingScreen(true));
        
        try {
          const userResponse = await fetch(`${process.env.REACT_APP_WEBAPP_URL}/api/user-info`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ initData }),
          });

          console.log('📡 Статус ответа:', userResponse.status);
          const userData = await userResponse.json();
          console.log('📦 Получены обновленные данные:', userData);

          if (userResponse.ok && userData) {
            console.log('🔄 Обновляем Redux данными:', userData);

            await dispatch({
              type: 'user/updateUserData',
              payload: userData
            });

            console.log('💾 Данные в Redux обновлены');
            
            setTimeout(() => {
              dispatch(setShowPaidLoadingScreen(false));
              dispatch(setIsPaid(true));
            }, 4000);
          } else {
            throw new Error('Некорректный ответ от сервера');
          }
        } catch (error) {
          console.error('❌ Ошибка при обновлении данных:', error);
          alert('Произошла ошибка при обновлении данных. Пожалуйста, перезагрузите страницу.');
          dispatch(setShowPaidLoadingScreen(false));
        }
      }
    });

    console.log('🔄 Открытие инвойса...');
    window.Telegram.WebApp.openInvoice(invoiceUrl);

  } catch (error) {
    console.error('❌ Критическая ошибка:', error);
    console.error('Stack trace:', error.stack);
  } finally {
    const initialLoader = document.querySelector('.loading-screen');
    if (initialLoader) {
      initialLoader.classList.add('fade-out');
      setTimeout(() => {
        initialLoader.style.display = 'none';
      }, 300);
    }
  }
}; 